import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merge class names; Tailwind utilities win over conflicts. BEM classes pass through. */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
